import dayjs from 'dayjs';
import { TaskResult } from './enums/task-result.enum';

export interface ITask {
  id?: number;
  creationDate?: dayjs.Dayjs | null;
  creatorLogin?: string | null;
  taskType?: TaskType | null;
  payload?: string | null;
  transporterId?: number | null;
  startTaskDate?: dayjs.Dayjs | null;
  endTaskDate?: dayjs.Dayjs | null;
  taskResult?: TaskResult | null;
  resultMessage?: string | null;
}

export class Task implements ITask {
  constructor(
    public id?: number,
    public creationDate?: dayjs.Dayjs | null,
    public creatorLogin?: string | null,
    public taskType?: TaskType | null,
    public payload?: string | null,
    public transporterId?: number | null,
    public startTaskDate?: dayjs.Dayjs | null,
    public endTaskDate?: dayjs.Dayjs | null,
    public taskResult?: TaskResult | null,
    public resultMessage?: string | null
  ) {}
}

export function getTaskIdentifier(task: ITask): number | undefined {
  return task.id;
}
